module.exports = __webpack_public_path__ + "static/media/bz.ecbe86bb.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bz.svg
// module id = 2057
// module chunks = 0